import { render, staticRenderFns } from "./AndroidHealthCard.vue?vue&type=template&id=4673dddc&scoped=true"
import script from "./AndroidHealthCard.vue?vue&type=script&lang=js"
export * from "./AndroidHealthCard.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthCard.vue?vue&type=style&index=0&id=4673dddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673dddc",
  null
  
)

export default component.exports